const { default: styled, css } = require('styled-components')

const Footer = styled.div`
  ${props =>
    css`
      padding-bottom: ${props.addBottomPadding && `40px`};

      @media (min-width: ${props.theme.size.breakpoint['min-width'].md}) {
        padding-bottom: 0;
      }
    `}
`

export { Footer }
